import { RootState } from "@/store"
import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface AppState {
  browserName: string
}

const initialState: AppState = {
  browserName: "",
}

const AppSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setBrowserName: (state, action: PayloadAction<string>) => {
      state.browserName = action.payload
    },
  },
})

export const { setBrowserName } = AppSlice.actions

export const selectBrowserName = (state: RootState) => state.app.browserName

export const selectIsChromiumBlinkBrowser = (state: RootState) => {
  const { browserName } = state.app
  return browserName === "Chrome" || browserName === "Edge"
}

export const selectIsSafariBrowser = (state: RootState) => {
  const { browserName } = state.app
  return browserName === "Safari"
}

export default AppSlice.reducer
